import type { FaireProductEntity } from "../../entity_types/product";

export const p_ccq4qjvj83: FaireProductEntity = {
  token: "p_ccq4qjvj83",
  type: "product",
  name: "Santal Life | Amber Sandalwood | 9 oz Candle | Holiday Gift",
  brandToken: "b_ymy9myk6jv",
  brandName: "Kandlery",
  imageUrl:
    "https://cdn.faire.com/fastly/39af0b3d8880705b8552182e31d16625868ff3abe6dd63b57948f71f9d83f08b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e0726e921fa3fd717b81ba42adda15d505dc7b0e87f8c205668917baad2f05df.jpeg",
    "https://cdn.faire.com/fastly/aacab90e461512e19ea1406126b4f2503407fd649ca15a10789cbe7fc22f4e57.jpeg",
    "https://cdn.faire.com/fastly/b54d1ea91befb429216b1474c785262c74b3c201c19628da3b6d0396792d4de9.png",
    "https://cdn.faire.com/fastly/1882a8521b9c0f7ee4b98c46b8593764b9ffae89b9fd944937f1b233dc53f00c.png",
  ],
  priceDollars: 17.5,
  description:
    "Santal Life candle is a warm, grounding scent built around sandalwood, gentle sweetness, and soft smoke.\n\nNotes of amber, cocoa, vanilla, cedar, spices, musk, and sandalwood create a calm atmosphere that feels both comforting and refined.\n\nSize options:\n9 oz. wood wicked gold tin with a lid\n\nNon-toxic | cruelty-free | pet-friendly\n\nProudly 'Made Better Certified'.\nOur goal is to source supplies with the highest quality standards in mind.\n\nWhy Kandlery?\n- Natural Coconut Wax\n- Crackling Wooden Wick, Made from FSC Certified Wood. \n- Lead free & Self-trimming Cotton Wick\n- Non Toxic Ingredients\n- Soothing Fragrances\n- Cruelty Free\n- Handcrafted in Small Batch\n- Untapped Asian-inspired scents",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:08.990Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
